import React, { useState,useEffect } from "react";
import mainlogo from "../../assets/mainlogo.png";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
// import backgroundImage from "../../assets/indian_trucker1.jpeg";
import backgroundImage from "../../assets/indian_trucker2.jpeg";
import image2 from "../../assets/istockphoto-1272130824-612x612.jpg";
import image3 from "../../assets/istockphoto-472109275-612x612.jpg";
import image4 from "../../assets/istockphoto-465151144-612x612.jpg";
import image5 from "../../assets/240_F_372527468_w6tA9bNWEKIq8JWsFl609ZKbb1NPH804.jpg";
import FadeInSection from "../../Components/FadeInSection";
import { testimonialApis,faqApis } from "../../Data/axios";
import config from "../../Data/AuthUser";

function Landing() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [testimonials, setTestimonials] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [openFaqIndex, setOpenFaqIndex] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch testimonials
        const resTestimonials = await testimonialApis.getAll({ limit: 3 });
        setTestimonials(resTestimonials.data || []);

        // Fetch FAQs
        const resFaqs = await faqApis.getAll();
        setFaqs(resFaqs.data?.slice(0, 5) || []); // Limit to 5 FAQs for the landing page
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  
  const toggleFAQ = (index) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };

  return (
    <>
      <Header />
      {/* <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Ubuntu:wght@400;500;700&display=swap');
          .landing-page body {
            font-family: 'Ubuntu', sans-serif;
          }
        `}
      </style> */}
      <div
        className="landing-page font-ubuntu"
        style={{ backgroundColor: "white" }}
      >
        <div
          className="flex flex-col items-center bg-white wall-home lg:h-[500px] md:h-[400px] sm:h-[350px] h-[300px] justify-center"
          style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundPosition: "50% 60%",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
          <div className="max-w-screen-xl mx-auto px-4 sm:px-6 w-full">
            <div>
              <div>
                <h2
                  className="text-4xl sm:text-5xl md:text-6xl lg:text-8xl font-extrabold text-white mb-5"
                >
                  Find Drivers the Easy Way.
                </h2>
                <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-4">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.rptpl.roadpilot"
                    target="_blank"
                    className="bg-csyellow text-white rounded-md px-4 py-2 text-center sm:text-left"
                    style={{
                      backgroundColor: "#f7c602",
                      borderRadius: "5px",
                    }}
                  >
                    Truck Drivers Start Here
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.rptpl.owner"
                    target="_blank"
                    className="bg-csyellow text-white rounded-md px-4 py-2 text-center sm:text-left"
                    style={{
                      backgroundColor: "#f7c602",
                      borderRadius: "5px",
                    }}
                  >
                    Companies Start Here
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="how-it-works"
          className="bg-white flex flex-col items-center pt-5 pb-5"
        >
          <div className="container mx-auto text-center px-4 sm:px-6">
            <div className="mx-auto mb-5 w-full sm:w-11/12 lg:w-3/4">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold mb-4">
                Truck Driver Agency <br className="hidden text-center sm:block"></br>Technology Driven
              </h1>
              <div className="text-base font-medium sm:text-lg text-center">
              Logistics is the backbone of commerce, with trucking as its driving force. In India, trucking fuels economic growth. Road Pilot Technologies Pvt Ltd stands out by offering a unique digital platform tailored for the core stakeholders of the trucking industry. <br />
              </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-3">
              <div className="flex flex-col sm:flex-row items-start">
                <img
                  src="https://cdn.prod.website-files.com/5ddb1ef6967a3b137f3684aa/6025aa67c3b12e42ccf03c02_Carrier%20sign%20up_mix.png"
                  alt=""
                  className="w-1/2 sm:w-1/4 mt-5 mb-2 sm:mr-2 mx-auto sm:mx-0"
                />
                <div>
                  <h5 className="text-lg font-bold mb-3">
                    Driving Success, Together
                  </h5>
                  <p className=" text-left font-medium sm:text-justify">
                  At RoadPilot Technologies, drivers are our priority. Whether you're a trucking business seeking skilled professionals or a logistics provider needing reliable drivers, we’re here to help.
                  </p>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row-reverse items-start">
                <img
                  src="https://cdn.prod.website-files.com/5ddb1ef6967a3b137f3684aa/6025aa68bb2f8f351e81b8b6_Carrier%20match%20candidates_mix.png"
                  alt=""
                  className="w-1/2 sm:w-1/4 mt-5 mb-2 sm:mr-2 mx-auto sm:mx-0"
                />
                <div>
                  <h5 className="text-lg font-bold mb-3">Find Drivers Fast</h5>
                  <p className=" text-left font-medium sm:text-justify">
                  We make finding reliable drivers easy. With our database of pre-vetted professionals, you can quickly connect with skilled drivers who match your specific needs and requirements.
                  </p>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row items-start">
                <img
                  src="https://cdn.prod.website-files.com/5ddb1ef6967a3b137f3684aa/609ec4dfda96a5b6e59c1575_Hand%20pick%20drivers.png"
                  alt="Review Drivers"
                  className="w-1/2 sm:w-1/4 mt-5 mb-2 sm:mr-2 mx-auto sm:mx-0"
                />
                <div>
                  <h5 className="text-lg font-bold mb-3">
                    Get Qualified Drivers
                  </h5>
                  <p className=" text-left font-medium sm:text-justify">
                  Our staffing agency ensures every driver is carefully screened for qualifications and experience. Hire hand-picked, job-ready truck drivers with RoadPilot.
                  </p>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row-reverse items-start">
                <img
                  src="https://cdn.prod.website-files.com/5ddb1ef6967a3b137f3684aa/609ec39ead98bfb4f2844501_7%20access_truckker.png"
                  alt=""
                  className="w-1/2 sm:w-1/4 mt-5 mb-2 sm:mr-2 mx-auto sm:mx-0"
                />
                <div>
                  <h5 className="text-lg font-bold mb-3">
                    Agile &amp; Responsive Online Service
                  </h5>
                  <p className=" font-medium text-left sm:text-justify">
                  Our driver staffing services are available online 24/7. Easily check request statuses, make new requests, or view applicants anytime, anywhere.
                    <br />
                  </p>
                </div>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row justify-center mt-10 sm:space-x-4 space-y-3 sm:space-y-0">
              <a
                href="https://play.google.com/store/apps/details?id=com.rptpl.roadpilot"
                className="bg-csyellow text-white rounded-md px-4 py-2 w-full sm:w-auto text-center"
              >
                Truck Drivers{" "}
                <span className="hidden sm:inline">Start Here</span>
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.rptpl.owner"
                className="bg-csyellow text-white rounded-md px-4 py-2 w-full sm:w-auto text-center"

              >
                Companies <span className="hidden sm:inline">Start Here</span>
              </a>
            </div>
          </div>
        </div>
        <div className="px-4 sm:px-6">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold mt-6 text-center text-black">
            Locations We Serve
          </h2>
          <div className="text-lg sm:text-xl md:text-2xl text-center">
            Here &#x27;s where carriers can find great drivers from RoadPilot.
          </div>
        </div>
        <div className="flex flex-col items-center bg-white pt-5 pb-5">
          <div className="container max-w-screen-xl mx-auto px-4 sm:px-6 text-center">
            <div className="w-full">
              <img src="./world-img.svg" alt="" className="w-full" />
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center bg-white py-5 px-4 sm:px-6">
          <div className="container mx-auto">
            <div className="text-center mb-5">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold">
                <strong>How you benefit</strong>
                <br />
              </h2>
            </div>
            <div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
                <div className="flex justify-center items-center">
                  <img
                    src="./mac-pro-2019-mockup.png"
                    className="w-full max-w-md lg:max-w-full"
                  />
                </div>
                <div className="px-2 sm:px-4">
                  <h3 className="text-xl sm:text-2xl font-bold mb-4">
                    <strong>
                      Why Choose RoadPilot for Trucking Driver Solutions?
                    </strong>
                    <br />
                  </h3>
                  <div className="space-y-3">
                    <p className="font-medium text-base sm:text-lg">
                      Streamline your operations with our tailored driver
                      staffing services, designed specifically for trucking
                      companies across India. Let us handle the hassle of
                      recruitment so you can focus on growing your business.{" "}
                    </p>
                    <h4 className="text-lg sm:text-xl font-bold">
                      Flexible Driver Solutions
                    </h4>
                    <p className="font-medium text-base sm:text-lg">
                      Whether you need drivers for a single trip, a seasonal
                      project, or a long-term assignment, we've got you covered
                      with a pool of skilled and reliable drivers ready to hit
                      the road.
                    </p>
                    <h4 className="text-lg sm:text-xl font-bold">
                      On-Demand Staffing Services
                    </h4>
                    <p className="font-medium text-base sm:text-lg">
                      Leverage our easy-to-use online platform and extensive
                      database of pre-screened drivers. Finding the right match
                      is just a few clicks away—anytime, anywhere.{" "}
                    </p>
                    <h4 className="text-lg sm:text-xl font-bold">
                      Qualified & Trustworthy Drivers
                    </h4>
                    <p className="font-medium text-base sm:text-lg">
                      Our drivers undergo a rigorous screening process to ensure
                      they meet the highest standards of professionalism,
                      safety, and expertise. You can trust us to provide the
                      best talent for your business needs.
                    </p>
                  </div>
                  <div className="mt-4">
                    <a
                      href="/features"
                      className="bg-csyellow text-white rounded-md px-4 py-2 inline-block"
                      style={{
                        backgroundColor: "#f7c602",
                        borderRadius: "5px",
                      }}
                    >
                      Learn more
                    </a>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 lg:flex-row-reverse mt-8">
                <div className="order-2 lg:order-1 px-2 sm:px-4">
                  <h3 className="text-xl sm:text-2xl font-bold mb-4">
                    Benefits for Truck Drivers
                  </h3>
                  <div className="space-y-4">
                    <p className="font-medium text-base sm:text-lg">
                      At RoadPilot, we make life easier for drivers across
                      India. Joining us is free, simple, and empowering. Once
                      you land your first job, you'll enjoy hassle-free payments
                      directly to your account. It's smooth and stress-free,
                      just like your rides should be!{" "}
                    </p>
                    <h4 className="text-lg sm:text-xl font-bold">
                      Effortless Job Search{" "}
                    </h4>
                    <p className="font-medium text-base sm:text-lg">
                      Explore new driving opportunities in no time. Sign up and
                      start receiving notifications about the best jobs tailored
                      for you. Your next big opportunity is just around the
                      corner.
                    </p>
                    <h4 className="text-lg sm:text-xl font-bold">
                      Maximize Earnings, Minimize Job Hunting
                    </h4>
                    <p className="font-medium text-base sm:text-lg">
                      We connect you with carriers offering competitive rates,
                      helping you earn more and spend less time searching for
                      jobs. It's a win-win for your wallet and your schedule.{" "}
                    </p>
                    <h4 className="text-lg sm:text-xl font-bold">
                      Highlight Your Skills and Experience
                    </h4>
                    <p className="font-medium text-base sm:text-lg">
                      Your RoadPilot profile puts the spotlight on your driving
                      expertise. It automatically builds your job history as you
                      go—no need to worry about constantly updating a CV. Let
                      your driving speak for itself!{" "}
                    </p>
                    <h4 className="text-lg sm:text-xl font-bold">
                      Stay Connected, Stay Informed
                    </h4>
                    <p className="font-medium text-base sm:text-lg">
                      With the RoadPilot app, you're always in the loop. From
                      accurate updates about your assignments to contact
                      information and routes, everything you need is at your
                      fingertips.
                    </p>
                  </div>
                  <div className="mt-4">
                    <a
                      href="/about"
                      className="bg-csyellow text-white rounded-md px-4 py-2 inline-block"
                      style={{
                        backgroundColor: "#f7c602",
                        borderRadius: "5px",
                      }}
                    >
                      Learn more
                    </a>
                  </div>
                </div>
                <div className="flex justify-center items-center order-1 lg:order-2">
                  <img
                    src="./woman-holding-smartphone-mockup.png"
                    className="w-full max-w-md lg:max-w-full"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center bg-white px-4 sm:px-6 py-5">
          <div className="container mx-auto my-5">
            <div className="grid grid-cols-1 lg:grid-cols-4 lg:grid-rows-4 gap-4">
              <div className="lg:col-span-2 lg:row-span-4">
                <img
                  src="./Untitled (7).png"
                  alt="Woman holding smartphone"
                  className="w-full h-full object-cover rounded-lg"
                />
              </div>
              <div className="lg:row-span-2 lg:col-start-3">
                <img
                  src={image5}
                  className="w-full h-full object-cover rounded-lg"
                />
              </div>
              <div className="lg:row-span-2 lg:col-start-3 lg:row-start-3">
                <img
                  src={image2}
                  className="w-full h-full object-cover rounded-lg"
                />
              </div>
              <div className="lg:row-span-2 lg:col-start-4 lg:row-start-1">
                <img
                  src={image3}
                  className="w-full h-full object-cover rounded-lg"
                />
              </div>
              <div className="lg:row-span-2 lg:col-start-4 lg:row-start-3">
                <img
                  src={image4}
                  className="w-full h-full object-cover rounded-lg"
                />
              </div>
            </div>
          </div>
        </div>
        <div id="how-it-works" className="py-5">
          <div className="container mx-auto my-5 px-4 sm:px-6">
            <div className="flex flex-col md:flex-row justify-between px-4 sm:px-8 md:px-16 lg:px-28 py-8 text-center">
              <div className="mb-8 md:mb-0">
                <h5 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold">40K+</h5>
                <p className="text-lg sm:text-xl mb-5">Drivers</p>
              </div>
              <div className="mb-8 md:mb-0">
                <h5 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold">13K+</h5>
                <p className="text-lg sm:text-xl mb-5">Owners</p>
              </div>
              <div>
                <h5 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold">5K+</h5>
                <p className="text-lg sm:text-xl mb-5">Clients</p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center bg-white px-4 sm:px-6 py-5">
          <div className="container mx-auto my-5 align-center">
            <div className="mb-20 w-full mx-auto">
              <div className="text-center text-base sm:text-xl md:text-2xl max-w-4xl mx-auto">
                We at Road Pilot are on a mission to restore the lost pride and
                honor of our truck drivers and fleet owners. We envision a
                future where every truck driver feels respected and valued, and
                where the gap between drivers and fleet owners is bridged,
                creating a harmonious and prosperous ecosystem
              </div>
            </div>
            <div className="w-full max-w-4xl mx-auto">
              <div className="relative pb-[56.25%] h-0 overflow-hidden max-w-full bg-black">
                <iframe
                  className="absolute top-0 left-0 w-full h-full"
                  src="https://www.youtube-nocookie.com/embed/-etgh38Ql84?si=YU5cVa8CyutFhpEZ&amp;controls=0"
                  title="RoadPilot - Shark Tank"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="pt-5 px-4 sm:px-6">
          <div className="container mx-auto text-center">
            <div className="mb-5 w-full sm:w-3/4 mx-auto">
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-center font-extrabold">
                Customer Testimonials
              </h2>
              <div className="text-base sm:text-lg md:text-xl text-center">
                Our clients trust us to take care of all their people management
                needs. RoadPilot, is one one of the largest suppliers of driver
                personnel.
              </div>
            </div>
            <div className="flex flex-col md:flex-row justify-between px-4 sm:px-8 md:px-16 lg:px-28 py-8 gap-6 items-center text-center">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="w-full md:w-1/3 mb-6 md:mb-0">
                  <p className="text-left font-medium sm:text-justify mb-2 flex-grow">
                    {testimonial.description}
                  </p>
                  <div className="font-bold pt-5">{testimonial.name}</div>
                </div>
              ))}
            </div>
          </div>

          
        </div> */}
        <div className="pt-5 px-4 sm:px-6">
  <div className="container mx-auto text-center">
    <div className="mb-5 w-full sm:w-3/4 mx-auto">
      <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-center font-extrabold">
        Customer Testimonials
      </h2>
      <div className="text-base sm:text-lg md:text-xl text-center">
        Our clients trust us to take care of all their people management needs. RoadPilot is one of the largest suppliers of driver personnel.
      </div>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 px-4 sm:px-8 md:px-16 lg:px-28 py-8">
      {testimonials.map((testimonial, index) => (
        <div
          key={index}
          className="bg-white shadow-lg rounded-lg p-6 flex flex-col items-center text-center"
        >
          {/* Profile Image */}
          <img
            src={`https://rptpl.roadpilot.co.in/public/${testimonial.image}`}  // Fallback image if no image is provided
            alt={testimonial.name}
            className="w-20 h-20 rounded-full object-cover mb-4"
          />
          {/* Name */}
          <div className="font-bold text-lg mb-2">{testimonial.name}</div>
          {/* Rating as Stars */}
          <div className="flex justify-center mb-4">
            {Array.from({ length: 5 }, (_, i) => (
              <svg
                key={i}
                xmlns="http://www.w3.org/2000/svg"
                fill={i < testimonial.rating ? "gold" : "none"}
                viewBox="0 0 24 24"
                stroke="currentColor"
                className={`w-5 h-5 ${i < testimonial.rating ? "text-yellow-500" : "text-gray-300"}`}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
                />
              </svg>
            ))}
          </div>
          {/* Description */}
          <p className="text-gray-600">{testimonial.description}</p>
        </div>
      ))}
    </div>
  </div>
</div>
        <div className="pt-5 pb-5 px-4 sm:px-6">
          <div className="container mx-auto text-center">
            <div className="w-full sm:w-3/4 md:w-1/2 mx-auto mb-5">
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-center">
                About RoadPilot
              </h2>
            </div>
            <div className="flex flex-col md:flex-row justify-between px-4 sm:px-8 md:px-16 lg:px-28 py-8 gap-6 items-start text-center">
              <div className="w-full md:w-1/3 mb-6 md:mb-0 flex flex-col items-center md:items-start">
                <h5 className="text-lg font-bold mb-2 text-center md:text-left">
                Simplifying Driver Hiring
                </h5>
                <p className="font-medium text-left sm:text-justify">
                RoadPilot is your trusted partner in finding skilled and reliable drivers. 
                We connect truck owners with pre-vetted professionals who are ready to hit the road. 
                Our platform ensures a seamless hiring process, saving you time and effort while 
                providing access to a pool of qualified drivers.
                </p>
              </div>
              <div className="w-full md:w-1/3 mb-6 md:mb-0 flex flex-col items-center md:items-start">
                <h5 className="text-lg mb-2 text-center md:text-left">
                Building Trust and Reliability
                </h5>
                <p className="font-medium text-left sm:text-justify">
                At RoadPilot, trust is at the core of everything we do. Our rigorous screening 
                process ensures that every driver meets the highest standards of safety and professionalism. 
                Whether you're a truck owner or a driver, you can rely on us to create a dependable 
                and transparent ecosystem.
                  <br />
                </p>
              </div>
              <div className="w-full md:w-1/3 flex flex-col items-center md:items-start">
                <h5 className="text-lg mb-2 text-center md:text-left">Scalable Trucking Solutions</h5>
                <p className="font-medium text-left sm:text-justify">
                RoadPilot offers scalable solutions tailored to your needs. Whether you're managing 
                a single truck or an entire fleet, our platform provides the tools and resources 
                to streamline your operations. From driver matching to real-time updates, we help 
                you stay ahead in the competitive trucking industry.
                  <br />
                </p>
              </div>
            </div>
            <div>
              <a
                href="/contact-us"
                className="bg-csyellow text-white rounded-md px-4 py-2 inline-block"
                style={{
                  backgroundColor: "#f7c602",
                  borderRadius: "5px",
                }}
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
        <div className="py-12 px-4 sm:px-6">
          <div className="container mx-auto text-center max-w-4xl">
            <FadeInSection animationType="up">
            <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold mb-4 text-center">
            Frequently Asked Questions
           </h2>
          </div>

              <div className="space-y-4">
                {faqs.map((faq, index) => (
                  <div
                    key={index}
                    className={`bg-white rounded-xl shadow-md overflow-hidden transition-all duration-300 ${
                      openFaqIndex === index ? "ring-2 ring-csyellow" : "hover:shadow-lg"
                    }`}
                  >
                    <button
                      className="w-full text-left px-6 py-5 flex justify-between items-center focus:outline-none"
                      onClick={() => toggleFAQ(index)}
                    >
                      <h3 className="text-lg font-medium text-gray-900">{faq.question}</h3>
                      <span
                        className={`ml-4 flex-shrink-0 transition-transform duration-300 ${
                          openFaqIndex === index ? "rotate-180" : ""
                        }`}
                      >
                        <svg
                          className="h-6 w-6 text-csyellow"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      </span>
                    </button>

                    <div
                      className={`px-6 overflow-hidden transition-all duration-300 ${
                        openFaqIndex === index ? "max-h-96 pb-6 opacity-100" : "max-h-0 opacity-0"
                      }`}
                    >
                      <div className="text-gray-600">{faq.answer}</div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="text-center mt-10">
                <a
                  href="/faqs"
                  className="bg-csyellow text-white rounded-md px-4 py-2 inline-block"
                  style={{
                    backgroundColor: "#f7c602",
                    borderRadius: "5px",
                  }}
                
                >
                  View All FAQs
                </a>
              </div>
            </FadeInSection>
          </div>
        </div> 
      </div>
      <Footer />
    </>
  );
}

export default Landing;
